import React from 'react';
import { View, Text, StyleSheet, Switch } from 'react-native';
import DigitalDisplay from './DigitalDisplay';
import PumpStatusBar from './PumpStatusBar';
import colors from '../../../config/colors';

/**
 * PumpHeroPanel - Blue gradient header with power display
 * Contains the main power metrics and pump status
 *
 * Props aligned with ESP32 MQTT fields:
 * - power: P (watts)
 * - amps: A (current)
 * - voltage: V
 * - pumpState: derived from pS (0=off, 1=running, 2=calibrating)
 * - uptimeSeconds: U
 * - currentRunTime: pRT (current run time in seconds, only when running)
 * - isCalibrated: pCal (0/1)
 * - calibrationRunCount: pCR
 * - totalRunCount: pTR
 */
function PumpHeroPanel({
    deviceName = 'My Pump',
    power = 0,
    amps = 0,
    voltage = 0,
    pumpState = 'monitoring', // 'running' | 'off' | 'monitoring' | 'calibrating'
    uptimeSeconds = 0,
    currentRunTime = 0,
    isCalibrated = false,
    calibrationRunCount = 0,
    totalRunCount = 0,
    showPowerToggle = false,
    powerEnabled = true,
    onPowerToggle,
}) {
    return (
        <View style={styles.container}>
            {/* Blue gradient section */}
            <View style={styles.heroSection}>
                {/* Power label with toggle */}
                <View style={styles.powerLabelRow}>
                    <Text style={styles.powerLabel}>POWER (W)</Text>
                    {showPowerToggle && (
                        <Switch
                            value={powerEnabled}
                            onValueChange={onPowerToggle}
                            trackColor={{ false: '#767577', true: '#81d4fa' }}
                            thumbColor={powerEnabled ? '#ffffff' : '#f4f3f4'}
                        />
                    )}
                </View>

                {/* Digital display */}
                <DigitalDisplay
                    power={power}
                    amps={amps}
                    voltage={voltage}
                />
            </View>

            {/* Status bar */}
            <PumpStatusBar
                pumpState={pumpState}
                uptimeSeconds={uptimeSeconds}
                currentRunTime={currentRunTime}
                isCalibrated={isCalibrated}
                calibrationRunCount={calibrationRunCount}
                totalRunCount={totalRunCount}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        overflow: 'hidden',
        borderRadius: 12,
        marginBottom: 16,
    },
    heroSection: {
        backgroundColor: colors.primary,
        paddingHorizontal: 20,
        paddingTop: 16,
        paddingBottom: 8,
    },
    powerLabelRow: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    powerLabel: {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#1a1a2e',
        letterSpacing: 1,
    },
});

export default PumpHeroPanel;
